"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapGqlPublicChannelToOld = exports.mapGqlPublicVideoToOld = void 0;
var globalTypes_1 = require("../generated/globalTypes");
var video_source_1 = require("../../mappers/video-source");
var pricing_1 = require("../../mappers/pricing");
var time_1 = require("@wix/wix-vod-shared/dist/src/common/utils/time");
var live_video_status_1 = require("../../private/mappers/live-video-status");
var live_status_1 = require("../../private/mappers/live-status");
var preview_types_1 = require("@wix/wix-vod-constants/dist/common/preview-types");
var mapGqlPublicVideoToOld = function (video) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        itemId: video.id,
        id: video.id,
        cast: video.cast,
        crew: video.crew.map(function (_a) {
            var role = _a.role, name = _a.name;
            return ({
                role: role,
                name: name,
            });
        }),
        title: video.title,
        publisher: video.publisher,
        genre: video.genre,
        dealInfo: video.pricing.map(pricing_1.mapVideoPricingToVod),
        posterUrl: video.poster.selected,
        coverUrl: video.cover.selected,
        allowDownload: video.downloadOptions.enabled,
        description: video.description,
        tags: video.tags,
        categories: video.categories,
        videoSource: video_source_1.videoSourceMapper.toVod(video.source),
        externalId: (_a = video.content) === null || _a === void 0 ? void 0 : _a.externalId,
        mediaExternUrl: (_b = video.content) === null || _b === void 0 ? void 0 : _b.externalUrl,
        contentUrl: video.play.entity.hls,
        durationSec: (_c = video.content) === null || _c === void 0 ? void 0 : _c.duration,
        durationStr: (0, time_1.convertMSToMMSS)((_d = video.content) === null || _d === void 0 ? void 0 : _d.duration),
        videoType: video.type,
        hasCards: video.cards.total !== 0,
        trailerFileName: (_e = video.uploadedTrailer) === null || _e === void 0 ? void 0 : _e.externalId,
        memberOnly: video.viewerOptions.signupRequired,
        embedOptions: video.embedOptions,
        liveVideoStatus: live_video_status_1.liveVideoStatusMapper.toVod((_f = video.live) === null || _f === void 0 ? void 0 : _f.status),
        itemType: live_status_1.liveStatusMapper.toVod((_g = video.live) === null || _g === void 0 ? void 0 : _g.status),
        dateStartLive: Date.parse((_h = video.live) === null || _h === void 0 ? void 0 : _h.startedAt) || undefined,
        previewType: video.viewerOptions.trailerEnabled
            ? video.viewerOptions.trailerUseUploaded
                ? preview_types_1.PREVIEW_TYPES.TRAILER
                : preview_types_1.PREVIEW_TYPES.FIRST_20_SEC
            : preview_types_1.PREVIEW_TYPES.NONE,
        datePublish: video.createdAt,
    };
};
exports.mapGqlPublicVideoToOld = mapGqlPublicVideoToOld;
var mapGqlPublicChannelToOld = function (channel) {
    return {
        itemId: channel.id,
        id: channel.id,
        title: channel.title,
        coverUrl: channel.cover.selected,
        description: channel.description,
        itemType: 'list',
        dealInfo: channel.pricing.map(pricing_1.mapChannelPricingToVod),
        videosCount: channel.videos.total,
        statsInfo: {
            categories: channel.categories.map(function (value) { return ({ value: value, count: 1 }); }),
            tags: channel.tags.map(function (value) { return ({ value: value, count: 1 }); }),
        },
        featuredItem: channel.featuredVideoId,
        mediaInfo: Boolean(channel.uploadedTrailer),
        channelType: channel.source === globalTypes_1.ChannelSource.INTERNAL ? 'channel' : 'youtube-feed',
    };
};
exports.mapGqlPublicChannelToOld = mapGqlPublicChannelToOld;
//# sourceMappingURL=mappers.js.map